import { SHADE_KEYS } from '../constans/styles';

type TShadeKeys = typeof SHADE_KEYS[number];

type TShadeColors = Record<Extract<TShadeKeys, 100 | 70 | 30 | 10>, string>;

interface IAccentColors {
  blue: TShadeColors;
  green: TShadeColors;
  orange: TShadeColors;
  red: TShadeColors;
  violet: TShadeColors;
}

interface ISupportColors {
  blue: TShadeColors;
  green: TShadeColors;
  orange: TShadeColors;
  red: TShadeColors;
  yellow: TShadeColors;
}

type TNeutralPrimaryColors = Record<TShadeKeys, string>;

interface INeutralColors {
  primary: TNeutralPrimaryColors;
  secondary: string;
}

const ACCENT_COLORS: IAccentColors = {
  blue: {
    100: '#2A7FAA',
    70: '#6AA6C4',
    30: '#C0D9E6',
    10: '#EAF2F7',
  },
  green: {
    100: '#0DAE89',
    70: '#56C6AD',
    30: '#B7E7DC',
    10: '#E7F7F3',
  },
  orange: {
    100: '#E69A6E',
    70: '#EEB89A',
    30: '#F5D7C5',
    10: '#FCF5F1',
  },
  red: {
    100: '#E37475',
    70: '#EB9E9F',
    30: '#F7D6D6',
    10: '#FCF1F1',
  },
  violet: {
    100: '#836AB2',
    70: '#A897C9',
    30: '#CDC3E0',
    10: '#F3F0F7',
  },
};

const NEUTRAL_COLORS: INeutralColors = {
  primary: {
    100: '#2D2D2D',
    90: '#434343',
    80: '#585858',
    70: '#6D6D6D',
    60: '#828282',
    50: '#979797',
    40: '#ABABAB',
    30: '#C0C0C0',
    20: '#D5D5D5',
    10: '#EAEAEA',
    5: '#F4F4F4',
    0: '#FFFFFF',
  },
  secondary: '#EAECEF',
};

const PRIMARY_COLORS: TShadeColors = {
  100: '#2A7FAA',
  70: '#6AA6C4',
  30: '#C0D9E6',
  10: '#EAF2F7',
};

const SECONDARY_COLORS: TShadeColors = {
  100: '#183A60',
  70: '#5E7590',
  30: '#BAC4D0',
  10: '#E8ECEF',
};

const SUPPORT_COLORS: ISupportColors = {
  blue: {
    100: '#3073FE',
    70: '#6F9DFF',
    30: '#ACC7FF',
    10: '#EBF1FF',
  },
  green: {
    100: '#05C6AC',
    70: '#50D8C5',
    30: '#9BE8DE',
    10: '#E6FAF7',
  },
  orange: {
    100: '#FF5D1B',
    70: '#FF8E60',
    30: '#FFBEA4',
    10: '#FFEFE9',
  },
  red: {
    100: '#E47272',
    70: '#EC9C9C',
    30: '#F4C7C7',
    10: '#FCF1F1',
  },
  yellow: {
    100: '#FBCB0C',
    70: '#FDDB55',
    30: '#FDEA9E',
    10: '#FFFAE7',
  },
};

export const COLORS = {
  accent: ACCENT_COLORS,
  neutral: NEUTRAL_COLORS,
  primary: PRIMARY_COLORS,
  secondary: SECONDARY_COLORS,
  support: SUPPORT_COLORS,
} as const;
